export const REMOVE_ANSWER_COUNTER = `
  done
`;
